(function () {
  "use strict";

  if (window.location.href.indexOf("/products") === -1) {
    console.log("Fox is not interested");
    return;
  }

  console.log("fox MPP & SP");
  //////////////////////// PROTECTION PLAN ////////////////////////////
  const protectionPlan = document.querySelector(
    "#convx__machines-protection-plan-container"
  );

  let optionsMPP = "",
    planIdMPP = "";

  if (protectionPlan) {
    optionsMPP = protectionPlan.querySelectorAll(
      ".convx__machines-protection-plan-option"
    );
    planIdMPP = parseInt(protectionPlan.dataset.planId);
  }

  //////////////////////// SCREEN PROTECTOR ////////////////////////////

  const screenProtector = document.querySelector(
    "#convx__machines-screen-protector-container"
  );
  let optionsSP = "",
    planIdSP = "";

  if (screenProtector) {
    optionsSP = screenProtector.querySelectorAll(
      ".convx__machines-screen-protector-option"
    );

    planIdSP = parseInt(screenProtector.dataset.planId);
  }

  if (planIdMPP == "" && planIdSP == "") {
    return;
  }

  //////////////////////// CONDITIONS //////////////////////////////////

  let currentPlanOptionMPP = "No";
  let currentPlanOptionSP = "No";

  //////////////////////// PROTECTION PLAN FUNCTION////////////////////////////

  if (protectionPlan) {
    optionsMPP.forEach((option) => {
      option.addEventListener("click", (event) => {
        let condition = option.children[0].dataset.option;
        if (condition == "Yes") {
          protectionPlan
            .querySelector(".convx__machines-protection-plan-price")
            .classList.remove("hide");
          protectionPlan
            .querySelector("#convx__btn-yes")
            .classList.add("convx__active");
          protectionPlan
            .querySelector("#convx__btn-no")
            .classList.remove("convx__active");

          currentPlanOptionMPP = "Yes";
          // updatePrice(event.target, condition);
        } else {
          protectionPlan
            .querySelector(".convx__machines-protection-plan-price")
            .classList.add("hide");
          protectionPlan
            .querySelector("#convx__btn-no")
            .classList.add("convx__active");
          protectionPlan
            .querySelector("#convx__btn-yes")
            .classList.remove("convx__active");
          currentPlanOptionMPP = "No";
          // updatePrice(event.target, condition);
        }
      });
    });
  }

  //////////////////////// SCREEN PROTECTOR FUNCTION ////////////////////////////
  if (screenProtector) {
    optionsSP.forEach((option) => {
      option.addEventListener("click", (event) => {
        let condition = option.children[0].dataset.option;
        if (condition == "Yes") {
          screenProtector
            .querySelector(".convx__machines-screen-protector-price")
            .classList.remove("hide");
          currentPlanOptionSP = "Yes";
          screenProtector
            .querySelector("#convx__btn-yes-sp")
            .classList.add("convx__active");
          screenProtector
            .querySelector("#convx__btn-no-sp")
            .classList.remove("convx__active");
          // updatePrice(event.target, condition);
        } else {
          screenProtector
            .querySelector(".convx__machines-screen-protector-price")
            .classList.add("hide");
          currentPlanOptionSP = "No";
          screenProtector
            .querySelector("#convx__btn-no-sp")
            .classList.add("convx__active");
          screenProtector
            .querySelector("#convx__btn-yes-sp")
            .classList.remove("convx__active");
          // updatePrice(event.target, condition);
        }
      });
    });
  }

  $("button[type='submit']").click(function (e) {
    if (currentPlanOptionMPP == "No" && currentPlanOptionSP == "No") {
      // console.log("fox return");
      return;
    }
    e.preventDefault();

    let product = [];
    let MPP = {
      id: planIdMPP,
      quantity: 1,
    };
    let SP = {
      id: planIdSP,
      quantity: 1,
    };

    if (currentPlanOptionMPP == "No") {
      product.push(SP);
    } else if (currentPlanOptionSP == "No") {
      product.push(MPP);
    } else {
      product.push(MPP);
      product.push(SP);
    }
    // console.log(typeof product);
    // console.log(product);
    // console.log("fox hello");
    // console.log(typeof JSON.stringify(product));
    // console.log(JSON.stringify(product));
    // console.log([
    //   {
    //     id: planIdSP,
    //     quantity: 1,
    //   },
    //   {
    //     id: planIdMPP,
    //     quantity: 1,
    //   },
    // ]);
    // console.log("Fox Confused");
    // return;

    let formData = {
      items: product,
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        $('form[action="/cart/add"').submit();
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
})();
